import {Component, Inject} from '@angular/core';
import {FlexLayoutModule} from "@angular/flex-layout";
import {MatButtonModule} from "@angular/material/button";
import {TranslateModule} from "@ngx-translate/core";
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';

@Component({
  selector: 'app-confirm-form',
  imports: [
    CommonModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    FlexLayoutModule,
    TranslateModule,
    ReactiveFormsModule
  ],
  templateUrl: './confirm-form.component.html',
  styleUrl: './confirm-form.component.scss'
})
export class ConfirmFormDialogComponent {
  title: string;
  message: string;
  paramValue: string;
  rejectionForm: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      message: string;
      param: string;
    },
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<ConfirmFormDialogComponent>
  ) {
    dialogRef.disableClose = true;
    this.title = data.title;
    this.message = data.message;
    this.paramValue = data.param;

    this.rejectionForm = this.formBuilder.group({
      rejectionJustification: ['', Validators.required],
    });
  }
  
  onConfirm() {
    if (this.rejectionForm.valid) {
      this.dialogRef.close({ confirm: true, justification: this.rejectionForm.value.rejectionJustification});
    }
  }

  onCancel() {
    this.dialogRef.close({ confirm: false });
  }
}
